import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useShopFlag } from "@/hooks/use-flag";
import useTranslation from "@babackapp/translations/use-translation";
import { DateRangePicker } from "@babackapp/ui/components/date-range-picker";
import { subMonths } from "date-fns";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { SizingConfigPanel } from "./components/sizing-config-panel";
import { SizingDiagnosticTable } from "./components/sizing-diagnostic-table";
import { SizingImpactSection } from "./components/sizing-impact-section";

const now = Date.now();
const threeMonthsAgo = subMonths(now, 3).getTime();

export default function SizingPage() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const isSizingEnabled = useShopFlag("isSizingEnabled");
  const [dateRange, setDateRange] = useState({
    from: threeMonthsAgo,
    to: now,
  });

  if (!isSizingEnabled) {
    return <Navigate to={`/shops/${shop.id}`} replace />;
  }

  return (
    <div className="flex items-center justify-center">
      <div className="grid grid-cols-4 gap-4 w-full max-w-[1600px] lg:px-16 lg:py-6 px-6 py-4">
        {/* Header */}
        <div className="col-span-4 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-semibold">
              {t("sizing.pageTitle")}
            </h2>
            <p className="text-sm text-muted-foreground mt-1">
              {t("sizing.pageSubtitle")}
            </p>
          </div>
          <DateRangePicker
            range={dateRange}
            onSelect={(range) => {
              if (range.from && range.to) {
                setDateRange({ from: range.from, to: range.to });
              }
            }}
          />
        </div>

        {/* Impact section */}
        <SizingImpactSection
          fromTimestamp={dateRange.from}
          toTimestamp={dateRange.to}
        />

        {/* Diagnostic table */}
        <SizingDiagnosticTable
          fromTimestamp={dateRange.from}
          toTimestamp={dateRange.to}
        />

        {/* Config panel */}
        <SizingConfigPanel />
      </div>
    </div>
  );
}
